"use client";

import Text from "@components/atoms/Text";
import Slider from "@components/atoms/Slider";
import { SliderInputProps } from "./SliderInput.types";
import styles from "./SliderInput.module.scss";

export const SliderInput = ({
  label,
  value,
  min,
  max,
  step,
  prefix="",
  suffix = "",
  onChange,
}: SliderInputProps) => (
  <div className={styles.sliderInput} >
    <div className={styles.labelRow}>
      {
        label && <Text className={styles.labelText}>{label}</Text>
      }
      <div className={styles.valueBox}>
        <Text className={styles.valueText}>
          {`${prefix}${value.toLocaleString()}`}
        </Text>
        <Text className={styles.suffixValueText}>
          {suffix}
        </Text>
      </div>
    </div>

    <Slider
      value={value}
      min={min}
      max={max}
      step={step}
      onChange={onChange}
      ariaLabel={label}
    />

    <div className={styles.rangeLabels}>
      <Text>{`${prefix}${min.toLocaleString()} ${suffix}`}</Text>
      <Text>{`${prefix}${max.toLocaleString()} ${suffix}`}</Text>
    </div>
  </div>
);
